import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import useRepeatCustomer from "./useRepeatCustomer";
import SendExcelData from "../../Admin/OrderList/SendExcelData";
import CustomDateRangePicker from "../../Global/CustomDateRangePicker";

const RepeatCustomer = () => {
  const {
    date,
    isLoading,
    isFetching,
    showEditModal,
    isExcelLinkSend,
    paginationOptions,
    repeatCustomerList,
    repeatCustomerState,
    handleRepeatCustomerExcelDownload,
    updateRepeatCustomerFields,
    handleEditColumnsClick,
    handleDateRangeChange,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    sendExcelData,
    handleSearch,
    modalClose,
    handleSort,
    refetch,
    getRow,
  } = useRepeatCustomer();
  return (
    <>
      <HeadingGroup title="Repeat Customer" className={`pro-mb-4`}>
        <div className="col dropdown-filter pro-d-flex">
          <button
            className={`pro-btn pro-btn-outline-primary no-wrap pro-items-center pro-ms-3`}
            type="submit"
            onClick={handleRepeatCustomerExcelDownload}
          >
            <span className="material-symbols-outlined x4">download</span>
            <span>{`Repeat Customer Data`}</span>
          </button>
        </div>
      </HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={repeatCustomerState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: repeatCustomerState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={false}
          dropDownFilter={
            <>
              <div className="col-auto">
                <CustomDateRangePicker
                  defaultDateRange={date}
                  handleDateRangeChange={handleDateRangeChange}
                />
              </div>
            </>
          }
          onDateChange={handleDateChange}
          initialDateRange={date}
        />
        {repeatCustomerList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={repeatCustomerList?.data?.result || []}
            uniqueID={"id"}
            fields={repeatCustomerList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={repeatCustomerState?.clearSelection}
            perpage={repeatCustomerState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}

        {repeatCustomerList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={repeatCustomerState?.currentPage}
            totalPageCount={Math.ceil(
              repeatCustomerList?.data.total_count /
                repeatCustomerState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === repeatCustomerState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={repeatCustomerList?.data?.fields || []}
              moduleId={repeatCustomerList?.data?.module_id}
              updateData={updateRepeatCustomerFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={repeatCustomerState.repeatCustomerExcelSendModal}
          handleClose={handleRepeatCustomerExcelDownload}
          title={`Send Excel Download Link`}
          backdrop="static"
        >
          <div className="pro-m-5">
            <SendExcelData
              isBestSeller
              handleCloseModal={modalClose}
              sendExcelData={sendExcelData}
              isExcelLinkSend={isExcelLinkSend}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default RepeatCustomer;
